import addMoneyMask from "../../../../utils/addMoneyMask";
import CardTag from "../cardTag";
import PlanCardTitle from "../planCardTitle";
import CardText from "../CardText";
import { getTagColor, getCardText, getTagText } from "./componentUtils";
import getFees from "../../../../utils/getFees";
import getDescontoParaPlano from "../../../../utils/compararDescontos";

const PlanCard = ({
  activeSlide,
  index,
  plan,
  selectedPlanID,
  selectedBemID,
  shouldBeFullHeight,
  options,
  updateCheckStatus,
}) => {
  return (
    <div
      className={`carousel-plan-item ${
        activeSlide === index ? "" : "carousel-plan-item--unavailable"
      }`}
    >
      <PlanCardTitle plan={plan} />
      {plan.planosTipos.map((tipo, index) => {
        const desconto = getDescontoParaPlano(tipo);

        return (
        <label
          className={`carousel-plan-checkbox
            ${
              selectedPlanID === tipo.planoID && tipo.bemId === selectedBemID
                ? "carousel-plan-checkbox--selected"
                : ""
            }
            ${
              shouldBeFullHeight(options) ? "carousel-plan-checkbox--full" : ""
            }`}
          key={index}
        >
          <div className="carousel-plan-box">
            <input
              type="checkbox"
              onChange={(event) => {
                updateCheckStatus(tipo.planoID, tipo.bemId);
              }}
              checked={
                tipo.planoID === selectedPlanID && tipo.bemId === selectedBemID
              }
            />
            <span className="carousel-plan-checkmark"></span>
          </div>
          <div className="carousel-plan-content">
            <div className="carousel-chips-container">
              <CardTag
                text={getTagText(tipo.name)}
                backgroundColor={getTagColor(tipo.name).backgroundColor}
                textColor={getTagColor(tipo.name).textColor}
                fontWeight={getTagColor(tipo.name).fontWeight}
              />
              {desconto && (
                <CardTag
                  text={`${desconto.desconto} na 1ª parcela`}
                  backgroundColor="#00A651"
                  textColor="#FFFFFF"
                  fontWeight="600"
                />
              )}
            </div>
            <div className="carousel-plan-strong">
              {addMoneyMask(tipo.valorParcela)}
              <span className="carousel-plan-message"> mensais</span>
            </div>
            {desconto ? (
              <span className="carousel-plan-desconto">
                Primeira parcela de{" "}
                <span className="carousel-plan-desconto-de">
                  {addMoneyMask(tipo.valorParcelaPrimeiroPagto)}
                </span>{" "}
                por{" "}
                <span className="carousel-plan-desconto-por">
                  {addMoneyMask(desconto.valorPrimeiraParcelaComDesconto)}
                </span>
              </span>
            ) : null}
            <span className="carousel-plan-description">
              {getFees(tipo).text} {getFees(tipo).value}
            </span>

            <CardText text={getCardText(tipo.name)} />
          </div>
        </label>
        );
      })}
    </div>
  );
};

export default PlanCard;
